import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/products/$id/scope/$nodeId/_layout/value/')({});